module.exports = __webpack_public_path__ + "img/afra.a15231e4.png";